import _ from 'lodash';
import { getFormValues, change } from 'redux-form';

import {
  FORM_NAME_EMPLOYEES_SEARCH,
  FORM_NAME_ATTENDANCES_SEARCH,
  FORM_NAME_PAYS_SEARCH,
  FORM_NAME_BONUSES_SEARCH,
  FORM_NAME_REVISION_MONTHS_SEARCH,
  FORM_NAME_NOTIFICATION_OF_BASE_AMOUNT_MONTHS_SEARCH,
  FORM_NAME_WAGE_LEDGER_SEARCH,
  FORM_NAME_ROLE_USERS_SEARCH,
  FORM_NAME_REPORT_HEALTH_INSURANCE_BONUS_SEARCH,
  FORM_NAME_WITHHOLDING_REPORT_SEARCH,
  FORM_NAME_AUDIT_LOGS_SEARCH,
  FORM_NAME_INCOME_TAX_DECLARATIONS_SEARCH,
  changeEmployeesSearchLocation,
  changePaysSearchLocation,
  changeBonusesLocation,
  changeRevisionsLocation,
  changeNotificationOfBaseAmountRevisionsLocation,
  changeWageLedgersLocation,
  changeClientRolesLocation,
  changeReportHealthInsuranceBonusLocation,
  changeWithholdingReportsLocation,
  changeAuditLogsLocation,
  changeIncomeTaxDeclarationsLocation
} from 'src/reducers/searchForm';

const debouncedAttendancesSearch = _.debounce(
  (dispatch, getState) => dispatch(changePaysSearchLocation(getFormValues(FORM_NAME_ATTENDANCES_SEARCH)(getState()))),
  1000
);
const debouncedPaysSearch = _.debounce(
  (dispatch, getState) => dispatch(changePaysSearchLocation(getFormValues(FORM_NAME_PAYS_SEARCH)(getState()))),
  1000
);
const debouncedEmployeesSearch = _.debounce(
  (dispatch, getState) =>
    dispatch(changeEmployeesSearchLocation(getFormValues(FORM_NAME_EMPLOYEES_SEARCH)(getState()))),
  1000
);
const debouncedBonusesSearch = _.debounce(
  (dispatch, getState) => dispatch(changeBonusesLocation(getFormValues(FORM_NAME_BONUSES_SEARCH)(getState()))),
  1000
);
const debouncedWageLedgersSearch = _.debounce(
  (dispatch, getState) => dispatch(changeWageLedgersLocation(getFormValues(FORM_NAME_WAGE_LEDGER_SEARCH)(getState()))),
  1000
);
const debouncedClientRolesSearch = _.debounce(
  (dispatch, getState) => dispatch(changeClientRolesLocation(getFormValues(FORM_NAME_ROLE_USERS_SEARCH)(getState()))),
  1000
);
const debouncedReportHealthInsuranceBonusSearch = _.debounce(
  (dispatch, getState) =>
    dispatch(
      changeReportHealthInsuranceBonusLocation(
        getFormValues(FORM_NAME_REPORT_HEALTH_INSURANCE_BONUS_SEARCH)(getState())
      )
    ),
  1000
);
const debouncedWithholdingReportsSearch = _.debounce(
  (dispatch, getState) => dispatch(changeWithholdingReportsLocation(getFormValues(FORM_NAME_WITHHOLDING_REPORT_SEARCH)(getState()))),
  1000
)

const debouncedAuditLogsSearch = _.debounce(
  (dispatch, getState) => dispatch(changeAuditLogsLocation(getFormValues(FORM_NAME_AUDIT_LOGS_SEARCH)(getState()))),
  1000
)

const debouncedIncomeTaxDeclarationsSearch = _.debounce(
  (dispatch, getState) => dispatch(changeIncomeTaxDeclarationsLocation(getFormValues(FORM_NAME_INCOME_TAX_DECLARATIONS_SEARCH)(getState()))),
  1000
);

export default store => next => action => {
  const result = next(action);

  if (action.type !== '@@redux-form/CHANGE') return result;

  const form = _.get(action, 'meta.form');
  const field = _.get(action, 'meta.field');

  if (field && field !== 'page') {
    const values = getFormValues(form)(store.getState());
    if (values?.page && values.page != 1) {
      store.dispatch(change(form, 'page', '1'));
    }
  }

  if (form === FORM_NAME_EMPLOYEES_SEARCH && action.type === '@@redux-form/CHANGE') {
    if (['sort', 'order'].includes(action.meta.field)) return result;

    if (['employmentType', 'limit'].includes(action.meta.field)) {
      store.dispatch(changeEmployeesSearchLocation(getFormValues(FORM_NAME_EMPLOYEES_SEARCH)(store.getState())));
    } else {
      debouncedEmployeesSearch(store.dispatch, store.getState);
    }
  }

  if (_.get(action, 'meta.form') === FORM_NAME_ATTENDANCES_SEARCH && action.type === '@@redux-form/CHANGE') {
    if (['uniquePayrollRuleGroups', 'sort', 'order'].includes(action.meta.field)) return result;

    if (['uniquePaymentDate', 'limit'].includes(action.meta.field)) {
      store.dispatch(changePaysSearchLocation(getFormValues(FORM_NAME_ATTENDANCES_SEARCH)(store.getState())));
    } else {
      debouncedAttendancesSearch(store.dispatch, store.getState);
    }
  }

  if (_.get(action, 'meta.form') === FORM_NAME_PAYS_SEARCH && action.type === '@@redux-form/CHANGE') {
    if (['uniquePayrollRuleGroups', 'sort', 'order'].includes(action.meta.field)) return result;

    if (['uniquePaymentDate', 'limit'].includes(action.meta.field)) {
      store.dispatch(changePaysSearchLocation(getFormValues(FORM_NAME_PAYS_SEARCH)(store.getState())));
    } else {
      debouncedPaysSearch(store.dispatch, store.getState);
    }
  }

  if (_.get(action, 'meta.form') === FORM_NAME_BONUSES_SEARCH && action.type === '@@redux-form/CHANGE') {
    if (['sort', 'order'].includes(action.meta.field)) return result;

    if (['clientBonusId', 'limit'].includes(action.meta.field)) {
      store.dispatch(changeBonusesLocation(getFormValues(FORM_NAME_BONUSES_SEARCH)(store.getState())));
    } else {
      debouncedBonusesSearch(store.dispatch, store.getState);
    }
  }

  if (_.get(action, 'meta.form') === FORM_NAME_REVISION_MONTHS_SEARCH) {
    if (action.type === '@@redux-form/CHANGE') {
      store.dispatch(changeRevisionsLocation(getFormValues(FORM_NAME_REVISION_MONTHS_SEARCH)(store.getState())));
    }
  }

  if (_.get(action, 'meta.form') === FORM_NAME_NOTIFICATION_OF_BASE_AMOUNT_MONTHS_SEARCH) {
    if (action.type === '@@redux-form/CHANGE') {
      store.dispatch(
        changeNotificationOfBaseAmountRevisionsLocation(
          getFormValues(FORM_NAME_NOTIFICATION_OF_BASE_AMOUNT_MONTHS_SEARCH)(store.getState())
        )
      );
    }
  }

  if (_.get(action, 'meta.form') === FORM_NAME_WAGE_LEDGER_SEARCH && action.type === '@@redux-form/CHANGE') {
    if (['sort', 'order'].includes(action.meta.field)) return result;

    if (['year', 'limit'].includes(action.meta.field)) {
      store.dispatch(changeWageLedgersLocation(getFormValues(FORM_NAME_WAGE_LEDGER_SEARCH)(store.getState())));
    } else {
      debouncedWageLedgersSearch(store.dispatch, store.getState);
    }
  }
  if (_.get(action, 'meta.form') === FORM_NAME_ROLE_USERS_SEARCH && action.type === '@@redux-form/CHANGE') {
    if (['sort', 'order'].includes(action.meta.field)) return result;

    if (['clientRoles', 'limit'].includes(action.meta.field)) {
      store.dispatch(changeClientRolesLocation(getFormValues(FORM_NAME_ROLE_USERS_SEARCH)(store.getState())));
    } else {
      debouncedClientRolesSearch(store.dispatch, store.getState);
    }
  }

  if (_.get(action, 'meta.form') === FORM_NAME_REPORT_HEALTH_INSURANCE_BONUS_SEARCH) {
    if (action.type === '@@redux-form/CHANGE') {
      if (['sort', 'order'].includes(action.meta.field)) return result;

      if (['bonusId', 'limit'].includes(action.meta.field)) {
        store.dispatch(
          changeReportHealthInsuranceBonusLocation(
            getFormValues(FORM_NAME_REPORT_HEALTH_INSURANCE_BONUS_SEARCH)(store.getState())
          )
        );
      } else {
        debouncedReportHealthInsuranceBonusSearch(store.dispatch, store.getState);
      }
    }
  }

  if (_.get(action, 'meta.form') === FORM_NAME_WITHHOLDING_REPORT_SEARCH && action.type === '@@redux-form/CHANGE') {
    if (['sort', 'order'].includes(action.meta.field)) return result;

    if (['year', 'limit'].includes(action.meta.field)) {
      store.dispatch(changeWithholdingReportsLocation(getFormValues(FORM_NAME_WITHHOLDING_REPORT_SEARCH)(store.getState())));
    } else {
      debouncedWithholdingReportsSearch(store.dispatch, store.getState);
    }
  }

  if (_.get(action, 'meta.form') === FORM_NAME_AUDIT_LOGS_SEARCH && action.type === '@@redux-form/CHANGE') {
    if (['sort', 'order'].includes(action.meta.field)) return result;

    if (['endDate', 'limit'].includes(action.meta.field)) {
      store.dispatch(changeAuditLogsLocation(getFormValues(FORM_NAME_AUDIT_LOGS_SEARCH)(store.getState())));
    } else {
      debouncedAuditLogsSearch(store.dispatch, store.getState);
    }
  }

  if (_.get(action, 'meta.form') === FORM_NAME_INCOME_TAX_DECLARATIONS_SEARCH && action.type === '@@redux-form/CHANGE') {
    if (['sort', 'order'].includes(action.meta.field)) return result;

    if (['page', 'limit'].includes(action.meta.field)) {
      store.dispatch(changeIncomeTaxDeclarationsLocation(getFormValues(FORM_NAME_INCOME_TAX_DECLARATIONS_SEARCH)(store.getState())));
    } else {
      debouncedIncomeTaxDeclarationsSearch(store.dispatch, store.getState);
    }
  }

  return result;
};
